<template>
<div>
  <v-row>
    <v-col cols="12" md="6">
      <v-radio-group v-model="value.tipoEmpresa" row 
        dense
        :disabled="this.estouEditando"
        :rules="[
                this.$validators.string.required,
          ]">
        <v-radio
          value="FOR"
          label="Fornecedor">
        </v-radio>
        <v-radio color="#efc00f"
          value="COM"
          label="Comprador">
        </v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" md="6">
      <search-box v-show="this.eComprador"
          dense
          :disabled="this.estouEditando"
          label="* Comprador"
          popup-label="Selecione um Comprador"
          :id.sync="value.idComprador"
          :nomeCompletoSemCnpj.sync="value.nomeCompletoCompradorSemCnpj"
          :hidden-clear="false"
          :value="comprador"
          :loader-fn="loadeComprador"
          item-key="id"
          item-text="nomeCompletoSemCnpj"
          :rules="this.validatorComprador"
          @input="selecionouComprador">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Comprador encontrado
          </p>
        </template>
      </search-box>
      <search-box v-show="this.eFornecedor"
          dense
          :disabled="this.estouEditando"
          label="* Fornecedor"
          popup-label="Selecione um Fornecedor"
          :id.sync="value.idFornecedor"
          :nomeCompletoSemCnpj.sync="value.nomeCompletoFornecedorSemCnpj"
          :hidden-clear="true"
          :value="fornecedor"
          :loader-fn="loadeFornecedor"
          item-key="id"
          item-text="nomeCompletoSemCnpj"
          :rules="this.validatorFornecedor"
          @input="selecionouFornecedor">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Fornecedor encontrado
          </p>
        </template>
      </search-box>
    </v-col>    
    <v-col cols="12" sm="6">
      <v-text-field label="* Nome"
                dense
                :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.greaterThanOrEquals(v, 1),
                  v => this.$validators.string.lessThanOrEquals(v, 100),
                ]"
                v-model.trim="value.nome"/>
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field label="* Cargo"
                dense
                :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.greaterThanOrEquals(v, 1),
                  v => this.$validators.string.lessThanOrEquals(v, 100),
                ]"
                v-model.trim="value.cargo"/>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field label="* Celular"
                    dense
                    v-mask="'(##) #####-####'"
                    :rules="[
                      this.$validators.string.required,
                    ]"
                    v-model.trim="value.celular"/>
    </v-col>
    <!-- ----------------------------------------------------  -->
    <v-col cols="12" sm="4">
      <v-text-field v-if="empresaEstrangeiraEmpresa"
                    :label="labelCpfResponsavel"
                    dense
                    placeholder="Registro do responsável"
                    :rules="rulesCpfResponsavel"
                    v-model.trim="value.cpf"/>
      <v-text-field v-else
                    :label="labelCpfResponsavel"
                    dense
                    placeholder="000.000.000-00"
                    :rules="rulesCpfResponsavel"
                    v-mask="'###.###.###-##'"
                    v-model.trim="value.cpf"/>
    </v-col>    
    <v-col cols="12" md="4">
      <v-text-field label="Telefone"
                    dense
                    v-mask="'(##) ####-####'"
                    v-model.trim="value.telefone"/>
    </v-col> 
    <v-col cols="12" md="4">
      <v-text-field label="Data Nascimento"
                    dense
                    type="date"
                    v-model="value.dataNascimento" />
    </v-col>
    <!-- ----------------------------------------------------  -->
    <v-col cols="12" sm="6">
      <v-text-field label="* Email"
                    dense
                    :rules="[
                      this.$validators.string.required,
                      this.$validators.string.email,
                      v => this.$validators.string.lessThanOrEquals(v, 50),
                    ]"
                    v-model.trim="value.email"/>
    </v-col>
    <v-col cols="12" md="6">
      <span v-if="this.estouEditando" >Para alterar a senha, somente pelo menu da lista: Alterar Senha</span>
      <v-text-field v-else label="* Senha"
                    dense
                    type="password"
                    :rules="[
                      this.$validators.string.required,
                      v => this.$validators.string.greaterThanOrEquals(v, 1),
                      v => this.$validators.string.lessThanOrEquals(v, 100),
                    ]"
                    v-model="value.senha"/>
    </v-col>
  </v-row>
</div>
</template>

<script>
import {findAll as findAllComprador} from "../../../api/comprador";
import {findAll as findAllFornecedor} from "../../../api/fornecedor";
import SearchBox from "../common/SearchBox";
import {mapGetters} from "vuex";

export default {
  name: "ContatoForm",
  components: {SearchBox},
  props: {
    value: {
      type: Object
    }
  },
  methods: {
    loadeComprador(page, search) {
      return findAllComprador(page, {
        nome: search,
      })
    },
    loadeFornecedor(page, search) {
      return findAllFornecedor(page, {
        nome: search,
      })
    },
    selecionouComprador(comprador) {
      this.$set(this.value, 'flgEmpresaEstrangeiraComprador', comprador?.flgEmpresaEstrangeira || 'N');
    },
    selecionouFornecedor(fornecedor) {
      this.$set(this.value, 'flgEmpresaEstrangeiraFornecedor', fornecedor?.flgEmpresaEstrangeira || 'N');
    },
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated', 'nivelUsuarioLogado']),
    estouEditando(){
      return Number(this.value?.id) > 0;
    },
    eComprador(){
      return this.value.tipoEmpresa == 'COM';
    },
    eFornecedor(){
      return this.value.tipoEmpresa == 'FOR';
    },
    comprador(){
      if (this.value.idComprador == null) return null;
      return {
        id: this.value.idComprador,
        nomeCompletoSemCnpj: this.value.nomeCompletoCompradorSemCnpj,
        flgEmpresaEstrangeira: this.value.flgEmpresaEstrangeiraComprador,
      }      
    },
    fornecedor(){
      if (this.value.idFornecedor == null) return null;
      return {
        id: this.value.idFornecedor,
        nomeCompletoSemCnpj: this.value.nomeCompletoFornecedorSemCnpj,
        flgEmpresaEstrangeira: this.value.flgEmpresaEstrangeiraFornecedor,
      }      
    },
    empresaEstrangeiraEmpresa() {
      if (this.eComprador) {
        return this.value?.flgEmpresaEstrangeiraComprador === 'S';
      }
      if (this.eFornecedor) {
        return this.value?.flgEmpresaEstrangeiraFornecedor === 'S';
      }
      return false;
    },
    labelCpfResponsavel() {
      return this.empresaEstrangeiraEmpresa ? '* Registro do responsável' : '* CPF';
    },
    rulesCpfResponsavel() {
      const rules = [this.$validators.string.required];
      if (this.empresaEstrangeiraEmpresa) {
        rules.push(v => this.$validators.string.greaterThanOrEquals(v, 1));
        rules.push(v => this.$validators.string.lessThanOrEquals(v, 50));
      } else {
        rules.push(this.$validators.string.cpf);
      }
      return rules;
    },
    validatorComprador() {
      return (this.eComprador ? [this.$validators.notNullOrUndefined] : []);
    },
    validatorFornecedor() {
      return (this.eFornecedor ? [this.$validators.notNullOrUndefined] : []);
    },
  }
}
</script>

<style scoped>

</style>